<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">Éléments descriptifs</p>
		</div>

		<div class="tle-row">
			<div class="tle-col half">
			<p class="label main_color_text">Caractéristiques de l’ensemble</p>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Epoque de construction</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="epoque_construction"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Type de produit</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="type_produit"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Nombre d'étages</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="nb_etages"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Caractéristiques de construction</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="carac_constr"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Accès sécurisé</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="acces_secure"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>État général</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="etat_general"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>État des parties communes</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="etat_commune"
					:editable="true"
				/>
				</span>
			</div>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Nombre de lots</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="nombre_lot"
					:editable="true"
				/>
				</span>
			</div>
			</div>
			<div class="tle-col half">
			<p class="label main_color_text">
				Caractéristiques du logement visité
			</p>
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Prestations</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="prestations"
					:editable="true"
				/>
				</span>
			</div>
			
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Équipements</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="equipements"
					:editable="true"
				/>
				</span>
			</div>
			
			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Mode de chauffage</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="chauffage"
					:editable="true"
				/>
				</span>
			</div>

			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Menuiseries</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="menuiseries"
					:editable="true"
				/>
				</span>
			</div>

			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>Annexes</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="annexes"
					:editable="true"
				/>
				</span>
			</div>

			<div
				class="el-closed-question dense"
				:class="{ 'can-change': editor.mode == 'editing' }"
			>
				<div class="question-label">
				<div>État</div>
				</div>
				<span class="question-value">
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.questions
					"
					property="etat"
					:editable="true"
				/>
				</span>
			</div>
			</div>
		</div>

		<div class="q-mb-sm">
			<div :class="{'tle-row' : true , 'margin-edition': editor.mode == 'editing'}">
				<div class="tle-col one-third">
				<el-image
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[0]
					"
					property="src"
					:editable="true"
					max_height="130px"
					edition_position="top"
				/>
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[0]
					"
					property="description"
					:editable="true"
					class="text-center text-italic image-description"
				/>
				</div>
				<div class="tle-col one-third">
				<el-image
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[1]
					"
					property="src"
					:editable="true"
					max_height="130px"
					edition_position="top"
				/>
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[1]
					"
					property="description"
					:editable="true"
					class="text-center text-italic image-description"
				/>
				</div>
				<div class="tle-col one-third">
				<el-image
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[2]
					"
					property="src"
					:editable="true"
					max_height="130px"
					edition_position="top"
				/>
				<el-textarea
					:parent_data="
					active_study.etudeData.scpi.elements_descriptifs.images[2]
					"
					property="description"
					:editable="true"
					class="text-center text-italic image-description"
				/>
				</div>
			</div>
		</div>

		<div class="comment">
			<el-textarea
				class="detail-site"
				:parent_data="active_study.etudeData.scpi.elements_descriptifs"
				property="commentaire"
				:editable="true"
				placeholder="Commentaire"
				:height="'70px'"
				overflow_edit='hidden scroll'
				text_align="justify"
			/>
		</div>

		<div>
			<h3 class="k-h3">
				Descriptif travaux prévus et budget
			</h3>
			<p>
				<el-textarea  :parent_data="active_study.etudeData.scpi.elements_descriptifs" property="description_travaux" :editable="true" inline />
			</p>
			<div class="overflow-hidden q-mt-sm">
				<div class="tle-row q-mt-sm">
					<div class="tle-col one-third">
						<el-square
							:parent_data="active_study.etudeData.scpi.elements_descriptifs"
							property="budget_travaux"
							label="Budget travaux envisagés :"
							format="string"
							suffix="€"
							:editable="true"
						/>
					</div>
					<div class="tle-col two-third">
						<p class="label-small">Etat d’avancement travaux au <el-textarea  :parent_data="active_study.etudeData.scpi.elements_descriptifs" property="date_avancement_travaux" :editable="true" inline /></p>
						<el-progress-slider
							:parent_data="active_study.etudeData.scpi.elements_descriptifs"
							property="accessibilite"
							:max="10"
							:editable="true"
						/>
					</div>
				</div>
			</div>
		</div>

		<el-table
			class="q-mt-md"
			:table="table_immeubles"
			:lines-obj="active_study.etudeData.scpi.elements_descriptifs"
			lines-field="immeubles_table_lignes"
			lines-box-class="left lefter toper"
			:nb-lines-max="active_study.etudeData.kyaneosData.Lots.length.toString()"
		/>
		<p v-if="table_overflow">Ce tableau n'intègre qu'un échantillon. Retrouvez l'intégralité des {{ this.active_study.etudeData.kyaneosData.Lots.length }} lots en annexe</p>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	components: { KyaneosHeader },
	name: "page-kyaneos-3",
	mixins: [ PageMixin ],
	props: [ "index" ],
	data: function () {
		return {
			max_row_table: 6
		};
	},
	computed: {
		...mapGetters([ "active_project", "active_study", "editor" ]),
		table_immeubles: function () {
			const table = { head: [], body: [], config: {
				cols_width: []
			} };

			table.head.push(["Code", "Type", "Surf. Hab.", "Type Bail", "Loyer", "État Locatif"]);

			const lots = this.active_study.etudeData.kyaneosData.Lots;
			const max_row_table = this.active_study.etudeData.scpi.elements_descriptifs.immeubles_table_lignes;
			const indexMax = this.table_overflow ? max_row_table - 1 : max_row_table;

			lots.forEach((lot, index) => {
				const loc = lots[index];
				if(index < indexMax){
					table.body.push([
						{
							parent_data: loc,
							property: "Code",
							editable: true,
						},
						{
							parent_data: loc.TypeLogement,
							property: "Libelle",
							editable: true,
						},
						{
							parent_data: loc,
							property: "Surface",
							editable: true,
						},
						{
							parent_data: loc,
							property: "TypeBail",
							editable: true,
						},
						{
							parent_data: loc,
							property: "Loyer",
							editable: true,
							suffix: "€"
						},
						{
							parent_data: loc,
							property: "EtatLocatif",
							editable: true
						},
					]);
				}
			});
			if(this.table_overflow){
				table.body.push([
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					}
				]);
			}
			return table;
		},
		table_overflow: function () {
			return this.active_study.etudeData.kyaneosData.Lots.length > this.active_study.etudeData.scpi.elements_descriptifs.immeubles_table_lignes;
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'
</style>